"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KuiperCooperative = void 0;
const Resources_1 = require("../../Resources");
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Tags_1 = require("../Tags");
const Size_1 = require("../render/Size");
const ResourceType_1 = require("../../ResourceType");
class KuiperCooperative extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.KUIPER_COOPERATIVE,
            tags: [Tags_1.Tags.SPACE, Tags_1.Tags.SPACE],
            startingMegaCredits: 33,
            resourceType: ResourceType_1.ResourceType.ASTEROID,
            metadata: {
                cardNumber: '??',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.megacredits(33).production((pb) => pb.titanium(1));
                    b.text('(You start with 1 titanium production and 33 M€.)', Size_1.Size.TINY, false, false);
                    b.corpBox('action', (ce) => {
                        ce.vSpace(Size_1.Size.LARGE);
                        ce.action('Add 1 asteroid here for every Space tag you have.', (eb) => {
                            eb.empty().startAction.asteroids(1).slash().space().played;
                        });
                        ce.vSpace(Size_1.Size.SMALL);
                        ce.effect('When you use the ASTEROID or AQUIFER standard projects, asteroids here may be used as 1 M€ each.', (eb) => {
                            eb.plate('Standard projects', Size_1.Size.SMALL).asterix().startEffect.asteroids(1).equals().megacredits(1);
                        });
                        ce.vSpace(Size_1.Size.SMALL);
                    });
                }),
            },
        });
        this.resourceCount = 0;
    }
    play(player) {
        player.addProduction(Resources_1.Resources.TITANIUM, 1);
        return undefined;
    }
    canAct() {
        return true;
    }
    action(player) {
        const spaceTagCount = player.getTagCount(Tags_1.Tags.SPACE);
        player.addResourceTo(this, { qty: spaceTagCount, log: true });
        return undefined;
    }
}
exports.KuiperCooperative = KuiperCooperative;
//# sourceMappingURL=KuiperCooperative.js.map